import { useChartDisplay } from '../../../../ui-components/data-viz-ui/charts/common/common-chart-utils/use-chart-display-reducer';
import { ComponentStateManager } from '../../../common/types';
import { OverTimeSegmentedVizExternalProps } from '../../types';
import {
  OverTimeSegmentedTableViewActions,
  OverTimeSegmentedTableViewState,
} from './types';

export const useOverTimeLineChartStateManager = (
  // We might need more props later, but I am not sure
  externalProps: OverTimeSegmentedVizExternalProps,
  persistenceKey: string
): ComponentStateManager<
  OverTimeSegmentedTableViewState,
  OverTimeSegmentedTableViewActions
> => {
  const { displayState, displayActions } = useChartDisplay(
    {
      enablePercentage: false,
      enableStack: false,
      enableLabels: false,
      enableLegend: false,
      enableSortOrder: false,
      enableTableView: false,
      globalDisplayState: externalProps.displayGlobalState,
    },
    persistenceKey
  );

  return {
    state: {
      displayState,
    },
    actions: {
      displayActions,
    },
  };
};
